import { useEffect, useRef, useState } from 'react';
import table from '../../assets/teaism/table.jpg';
import bowls from '../../assets/teaism/bowls.jpg';
import bento from '../../assets/teaism/bento.jpg';
// Organizer-supplied photos and menu: Images/teaism and docs/PQ_Menu_June_2026.pdf.
const photos = [
  { src: table, alt: 'A spread of food and tea at Teaism' },
  { src: bento, alt: 'A Teaism bento meal beside a pot of tea' },
  { src: bowls, alt: 'Bowls of food served at Teaism' },
];
const paragraphs = [
  'It may take some time for our systems to contemplate everything happening in the world. Now’s a great time to try a hot chai, cool off with a ginger limeade, or place an order for a Salty Oat cookie. The future can wait a moment. Your tea break doesn’t have to.',
  'A warm thank-you to Teaism in Penn Quarter for giving Nerds at Play a place to gather, imagine, and debate what comes next.',
  'Please purchase at least one item tonight to support our hosts and help us keep using this space for future events. Already ordered? Thank you for helping make this gathering possible.',
];
export function SponsorInterlude({
  gm = false,
  gameId,
  round,
}: {
  gm?: boolean;
  gameId: string;
  round: number;
}) {
  const storageKey = `nap-sponsor-${gameId}-${round}`;
  const [minimized, setMinimized] = useState(() => {
    try {
      return sessionStorage.getItem(storageKey) === 'hidden';
    } catch {
      return false;
    }
  });
  const [status, setStatus] = useState('');
  const modal = useRef<HTMLDialogElement>(null);
  const ribbon = useRef<HTMLButtonElement>(null);
  const photo = photos[(round - 1) % photos.length]!;
  const remember = () => {
    setMinimized(true);
    try {
      sessionStorage.setItem(storageKey, 'hidden');
    } catch {
      /* Ribbon still works without storage. */
    }
  };
  useEffect(() => {
    const element = modal.current;
    if (!minimized && element && !document.querySelector('dialog[open]')) element.showModal();
    return () => element?.close();
  }, [minimized]);
  return (
    <>
      <aside className="sponsor-ribbon" aria-label="Sponsor announcement">
        <span>While the world takes shape · Tea, treats & a thank-you to Teaism</span>
        <button ref={ribbon} type="button" onClick={() => modal.current?.showModal()}>
          Open sponsor announcement
        </button>
      </aside>
      <dialog
        ref={modal}
        className="sponsor-modal"
        aria-labelledby="sponsor-title"
        onClose={() => {
          if (modal.current?.open) return;
          remember();
          ribbon.current?.focus();
        }}
      >
        <header>
          <span>A word from our sponsors</span>
          <button
            type="button"
            onClick={() => {
              remember();
              modal.current?.close();
            }}
          >
            Hide to ribbon
          </button>
        </header>
        <img src={photo.src} alt={photo.alt} />
        <div className="sponsor-copy">
          <small>Teaism · Penn Quarter</small>
          <h2 id="sponsor-title">A good moment for something delicious.</h2>
          {paragraphs.map((text) => (
            <p key={text}>{text}</p>
          ))}
          {gm && (
            <>
              <button
                type="button"
                onClick={() => {
                  void (async () => {
                    try {
                      await navigator.clipboard.writeText(
                        'A word from our sponsors: Teaism, Penn Quarter.\n\n' +
                          paragraphs.join('\n\n'),
                      );
                      setStatus('Announcement copied.');
                    } catch {
                      setStatus('Select the announcement and copy it manually.');
                    }
                  })();
                }}
              >
                Copy sponsor script
              </button>
              <p role="status">{status}</p>
            </>
          )}
        </div>
      </dialog>
    </>
  );
}
